import type { History } from 'history';

// Reads the URL when it replaces it, not from an earlier snapshot, so a param another effect has
// removed in the meantime (e.g. `view` after its async load) isn't put back.
export const replaceSearchParams = (history: History, params: URLSearchParams) => {
  // Params without a value stay bare, so Fleet's `?blade` doesn't become `?blade=`
  const search = params.toString().replace(/=(?=&|$)/g, '');
  history.replace({ search: search ? `?${search}` : '' });
};

export const removeSearchParam = (history: History, key: string) => {
  const params = new URLSearchParams(history.location.search);
  params.delete(key);
  replaceSearchParams(history, params);
};
